import ServiceHeader from "../../ServiceComponents/ServiceHeader";
// import { FaGreaterThan } from "react-icons/fa6";
export default function RegistrationFirstSection() {
    return (
        <>
            <ServiceHeader
                childClass="registrationSection"
                breadcrumb={<> Registration</>}
                title="Registration"
            />
        </>
    )
}